import { type ReactNode, useMemo } from 'react';

import { type MessageDescriptor, useIntl } from 'react-intl-next';

import type { FallbackUrl, GlobalShortcutLinkItem } from '../../types';

export const useAppGlobalShortcutLinkItem = (
	icon: ReactNode,
	label: MessageDescriptor,
	fallbackUrl: FallbackUrl,
	options?: Pick<
		GlobalShortcutLinkItem,
		'labelElem' | 'apsKey' | 'ref' | 'analyticsName' | 'menuItemId'
	>,
): GlobalShortcutLinkItem => {
	const { labelElem, apsKey, ref, analyticsName, menuItemId } = options ?? {};
	const { formatMessage } = useIntl();
	return useMemo(
		() => ({
			type: 'link',
			icon,
			label: formatMessage(label),
			labelElem,
			apsKey,
			fallbackUrl,
			ref,
			analyticsName,
			...(menuItemId ? { menuItemId } : {}),
		}),
		[apsKey, fallbackUrl, formatMessage, icon, label, labelElem, ref, analyticsName, menuItemId],
	);
};
